import React, { useState, useEffect } from 'react';
import { Statistic, Card, Row, Col, Carousel } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

import DescriptionList from 'ant-design-pro/lib/DescriptionList';
import moment from 'moment';
import './index.css';
import jwt from 'jwt-decode';
import General from './General';

const contentStyle = {
  minHeight: '350px',
  color: '#fff',
  lineHeight: '350px',
  textAlign: 'center',
  background: '#364d79',
};

const Home = () => {
  const [userRole, setUserRole] = useState('');
  const visitData = [];
  const beginDay = new Date().getTime();
  for (let i = 0; i < 20; i += 1) {
    visitData.push({
      x: moment(new Date(beginDay + 1000 * 60 * 60 * 24 * i)).format('YYYY-MM-DD'),
      y: Math.floor(Math.random() * 100) + 10,
    });
  }

  useEffect(() => {
    if (!!localStorage['token']) {
      const persistedToken = jwt(localStorage['token']);
      setUserRole(persistedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']);
    }
  }, [])

  return (
    <React.Fragment>
      {['admin'].indexOf(userRole) === -1 ?
        <>
          <Carousel autoplay>
            <div>
              <h3 style={contentStyle}>1</h3>
            </div>
            <div>
              <h3 style={contentStyle}>2</h3>
            </div>
            <div>
              <h3 style={contentStyle}>3</h3>
            </div>
            <div>
              <h3 style={contentStyle}>4</h3>
            </div>
          </Carousel>
          <div className="site-statistic-demo-card" style={{ marginTop: 24 }}>
            <Row gutter={16}>
              <Col span={12}>
                <Card>
                  <Statistic
                    title="Active"
                    value={11.28}
                    precision={2}
                    valueStyle={{ color: '#3f8600' }}
                    prefix={<ArrowUpOutlined />}
                    suffix="%"
                  />
                </Card>
              </Col>
              <Col span={12}>
                <Card>
                  <Statistic
                    title="Idle"
                    value={9.3}
                    precision={2}
                    valueStyle={{ color: '#cf1322' }}
                    prefix={<ArrowDownOutlined />}
                    suffix="%"
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </> :
        <General />
      }
    </React.Fragment >
  );
};

export default Home;
